import * as Types from '../../../modules/decisionsNext/api/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type ReorderSavedFiltersMutationVariables = Types.Exact<{
  reorderedList: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReorderSavedFiltersMutation = { __typename?: 'Mutation', reorderFilters: { __typename?: 'StoredFiltersUpdateLastUserResponse', success: boolean } };


export const ReorderSavedFiltersDocument = gql`
    mutation ReorderSavedFilters($reorderedList: [String!]!) {
  reorderFilters(filterIds: $reorderedList) {
    success
  }
}
    `;
export type ReorderSavedFiltersMutationFn = Apollo.MutationFunction<ReorderSavedFiltersMutation, ReorderSavedFiltersMutationVariables>;

/**
 * __useReorderSavedFiltersMutation__
 *
 * To run a mutation, you first call `useReorderSavedFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderSavedFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderSavedFiltersMutation, { data, loading, error }] = useReorderSavedFiltersMutation({
 *   variables: {
 *      reorderedList: // value for 'reorderedList'
 *   },
 * });
 */
export function useReorderSavedFiltersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderSavedFiltersMutation, ReorderSavedFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderSavedFiltersMutation, ReorderSavedFiltersMutationVariables>(ReorderSavedFiltersDocument, options);
      }
export type ReorderSavedFiltersMutationHookResult = ReturnType<typeof useReorderSavedFiltersMutation>;
export type ReorderSavedFiltersMutationResult = Apollo.MutationResult<ReorderSavedFiltersMutation>;
export type ReorderSavedFiltersMutationOptions = Apollo.BaseMutationOptions<ReorderSavedFiltersMutation, ReorderSavedFiltersMutationVariables>;